module.exports = __webpack_public_path__ + "img/MACHO_13-24.5187e80a.jpeg";